var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.666A6.669 6.669 0 0013.667 7 6.669 6.669 0 007 .333 6.669 6.669 0 00.333 7 6.669 6.669 0 007 13.666zM6.225 3.561a.468.468 0 01.937 0v3.536l1.953 1.468c.21.162.242.452.097.662a.452.452 0 01-.372.194.438.438 0 01-.274-.097L6.419 7.71a.474.474 0 01-.194-.371V3.56z"
  })));
}

export default SvgClock;